const accordion = document.querySelectorAll(".js-toggle");

accordion.forEach(function (accordionToggle) {
    accordionToggle.addEventListener("click", function () {
        const content = this.nextElementSibling;
        content.classList.toggle("is-open");
        const accordion = this;
        accordion.classList.toggle("js-open");
    });
});
